<template>
  <v-container fluid id="crm">
    <v-layout wrap justify-end>
      <v-flex xs12 class="text-sm-right">
        <template>
          <v-btn
            v-if="$store.getters.getPackage != 'premium'"
            outline
            v-tooltip.top="'Unlock to PREMIUM plan'"
            color="grey"
            class="ma-0 mb-1"
          >
            <em class="fas fa-file-export mr-1" />
            {{ $t('export') }}
            <v-premium-lock></v-premium-lock>
          </v-btn>
          <v-btn
            v-else-if="$store.getters.getPackage == 'premium'"
            @click="exportDashboard"
            color="grey"
            outline
            class="ma-0 mb-1"
          >
            <em class="fas fa-file-export mr-1" />
            {{ $t('export') }}
          </v-btn>
        </template>
      </v-flex>
    </v-layout>
    <date-filter @changeDate="getEp" :fullsize="false" v-model="selectedDate"></date-filter>
    <div>
      <multiselect
        v-model="selectEp"
        :options="ep"
        placeholder="Select Episode"
        @input="fetchDataChart"
        class="mt-2"
      ></multiselect>
    </div>
    <div>
      <v-layout class="mb-5" row right>
        <v-btn color="gray" outline @click="clearFilter">{{ $t('Clear Search') }}</v-btn>
      </v-layout>
    </div>
    <div class="mt-5">
      <apexchart
        :key="barchartkey"
        type="bar"
        height="600"
        width="100%"
        :options="options"
        :series="series"
      ></apexchart>
    </div>
  </v-container>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
import Multiselect from 'vue-multiselect'
import moment from 'moment'
import DateFilter from './TheNextFaceDateFilter'
import VueApexCharts from 'vue-apexcharts'
import XLSX from 'xlsx'

export default {
  data() {
    return {
      barchartkey: 0,
      ep: [],
      selectEp: '',
      filter: 'all',
      selectedDate: {
        start: null,
        end: null
      },
      chartData: [],
      total: 0,
      series: [
        {
          name: 'Vote',
          data: []
        }
      ],
      options: {
        // states: {
        //   hover: {
        //     filter: {
        //       type: 'none'
        //     }
        //   }
        // },
        dataLabels: {
          formatter: (val, opt) => {
            let total = this.total
            var percentdata = Math.round(Number((parseFloat(val) / total) * 100))
            return `${val} (${percentdata + '%'})`
          }
        },
        colors: [
          '#151D3B',
          '#D82148',
          '#6EBF8B',
          '#DADBBD',
          '#6A5495',
          '#ED5EDD',
          '#8BDB81',
          '#E7ED9B',
          '#313552',
          '#B8405E',
          '#2EB086',
          '#EEE6CE',
          '#FFE162',
          '#FF6464',
          '#91C483',
          '#24A19C',
          '#325288',
          '#D96098',
          '#FFAD60',
          '#96CEB4'
        ],
        chart: {
          height: 600
          // type: 'bar'
        },
        plotOptions: {
          bar: {
            horizontal: false,
            distributed: true
          }
        },
        xaxis: {
          categories: [],
          position: 'bottom',
          labels: {
            style: {
              colors: this.colors,
              fontSize: '12px'
            }
          }
        },
        yaxis: {
          show: false,
          axisBorder: {
            show: false
          },
          max: this.maxY,
          forceNiceScale: true,
          axisTicks: {
            show: false
          }
        }
      }
    }
  },
  components: { Multiselect, DateFilter, apexchart: VueApexCharts },
  computed: {
    ...mapGetters(['selectedBot']),
    exportData() {
      let data = []
      this.chartData.forEach((ele) => {
        data.push({
          Episode: this.selectEp,
          Contestants: ele.name,
          Vote: ele.vote,
          Percentage: Math.round(Number((parseFloat(ele.vote) / this.total) * 100)) + '%'
        })
      })
      return data
    }
  },
  mounted() {
    this.setup()
  },
  methods: {
    setup() {
      this.getEp()
    },
    fetchDataChart() {
      this.getvotingresult()
    },
    exportDashboard() {
      if (this.exportData.length) {
        let json = this.exportData
        try {
          console.log(json)
          const dataWS = XLSX.utils.json_to_sheet(json)
          const wb = XLSX.utils.book_new()
          XLSX.utils.book_append_sheet(wb, dataWS)
          XLSX.writeFile(wb, 'zwizdata-matrics.xlsx')
        } catch (error) {
          console.error(error)
        }
      }
    },
    updateApex() {
      this.options.xaxis.categories = this.chartData.map((v) => v.name)
      this.total = 0
      this.chartData.forEach((ele) => {
        this.total = parseInt(this.total) + parseInt(ele.vote)
      })
      this.series[0].data = this.chartData.map((v) => v.vote)
      this.barchartkey += 1
    },
    async clearFilter() {
      this.selectedDate.start = null
      this.selectedDate.end = null
      this.selectEp = ''
      await this.getEp(false)
    },
    async getEp(selected = true) {
      let data = {
        pageid: this.selectedBot.pageid,
        datefrom: this.selectedDate.start,
        dateto: this.selectedDate.end,
        app: this.filter
      }
      let res = await api.geteplist(data)
      if (res) {
        this.ep = res.length > 1 ? ['all', ...res] : res
        if (res.length && selected) {
          this.selectEp = res[0]
          this.fetchDataChart()
        } else {
          this.selectEp = ''
          this.chartData = []
          this.updateApex()
        }
      } else {
        this.ep = []
        this.selectEp = ''
        this.chartData = []
        this.updateApex()
      }
    },
    async getvotingresult() {
      let data = {
        pageid: this.selectedBot.pageid,
        datefrom: this.selectedDate.start,
        dateto: this.selectedDate.end,
        namespace: this.selectEp,
        app: this.filter
      }
      let res = await api.getVotingResult(data)
      if (res) {
        this.chartData = res
        this.updateApex()
      } else {
        this.chartData = []
        this.updateApex()
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/dashboard/Voteresult.vue